module.exports = __webpack_public_path__ + "img/default.224ea6ca.jpg";